import { render, staticRenderFns } from "./retailfooter.vue?vue&type=template&id=2946be75"
import script from "./retailfooter.vue?vue&type=script&lang=js"
export * from "./retailfooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports